// extracted by mini-css-extract-plugin
export default {"titre":"Mentions_titre__0Np8A","texte":"Mentions_texte__GeGQv","soustitre":"Mentions_soustitre__9OQnF","dernier":"Mentions_dernier__XTFZY"};